import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";

Vue.use(Vuetify);
@Component({
  name: "ViewIframeModal"
})
export default class ViewIframeModal extends Vue {
  @Prop() url!: string;
  @Prop() viewDialog!: boolean;

  cardClass = STYLE_CLASSES.CARD;

  close() {
    this.$emit("closeIframe");
  }
}
